export default __webpack_public_path__ + "static/media/ethpurple.4aa4d7e0.png";